// services/authService.js
import { toast } from "react-toastify"; // Import toast
import secureStorage from "./utils/secureStorage";
const API_URL = process.env.REACT_APP_API_URL;

export const validateToken = async (navigate) => {
  try {
     const token    = secureStorage.get("authToken");   
    const clinicId = secureStorage.get("clinic"); 
    if (!token) {
      console.log("No token found. Redirecting to login.");
      toast.error("Login expired. Please re-login."); // Show the toast
      navigate("/login");
      return false;
    }
    const response = await fetch(`${API_URL}hospital/validate`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "X-HIP-ID": clinicId,
      },
    });

    if (response.ok) {
      console.log("Token validated successfully.");
      return true;
    } else if (response.status === 401) {
      console.error("Unauthorized. Redirecting to login.");
      toast.error("Login expired."); // Show the toast
      localStorage.clear();
      navigate("/login");
      return false;
    } else {
      console.error("Failed to validate token:", response.statusText);
      navigate("/login");
      return false;
    }
  } catch (error) {
    console.error("Error occurred while validating token:", error);
    toast.error("Login expired. Please re-login."); // Show the toast
    localStorage.clear();
    navigate("/login");
    return false;
  } finally {
    console.log("Token validation process completed.");
  }
};
